import React from 'react';
import { MemberPortal as InnerPortal } from './MemberPortalInner';

// Existing /members route now just renders the inner portal — auth is handled by ProtectedRoute in App.js
export const MemberPortal = () => <InnerPortal />;
